import React from "react";
import TextField from "@mui/material/TextField";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import TimePicker from "@mui/lab/TimePicker";
import esLocale from "date-fns/locale/es";

const CustomTimePicker = ({
  size = "medium",
  register,
  name,
  label,
  hashError = null,
  value = null,
  required = false,
  disabled = false,
  cancelText = "Cancelar",
  okText = "Aceptar",
  clearText = "Limpiar",
  format = "hh:mm",
  leftArrowButtonText = "Anterior",
  rightArrowButtonText = "Siguiente",
  ampm = false,
  clearable = false,
  orientation,
  onChange = null,
  onOpen = null,
  onClose = null,
  onAccept = null,
  loading = false,
}) => {
  const handleChange = (data) => {
    if (onChange) {
      onChange(data);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} locale={esLocale}>
      <TimePicker
        size={size}
        leftArrowButtonText={leftArrowButtonText}
        rightArrowButtonText={rightArrowButtonText}
        disabled={disabled}
        name={name}
        id={name}
        okText={okText}
        clearText={clearText}
        cancelText={cancelText}
        label={label}
        ampm={ampm}
        format={format}
        orientation={orientation ? orientation : "portrait"}
        clearable={clearable}
        value={value}
        loading={loading}
        onOpen={onOpen}
        onClose={onClose}
        onAccept={onAccept}
        onChange={handleChange}
        renderInput={(params) => (
          <TextField
            {...params}
            error={hashError ? hashError.value : false}
            helperText={hashError ? hashError.message : ""}
            {...register(name, {
              required: required,
            })}
          />
        )}
      />
    </LocalizationProvider>
  );
};

export default CustomTimePicker;

